import { useCallback, useState } from 'react';

interface Params {
  selectedIds: string[];
  applyFunds: (invoiceIds: string[]) => Promise<unknown>;
  onApplied: () => void;
}

export const useApplyFundsFlow = ({ selectedIds, applyFunds, onApplied }: Params) => {
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const openConfirm = useCallback(() => setIsConfirmVisible(true), []);
  const closeConfirm = useCallback(() => setIsConfirmVisible(false), []);
  const closeSuccess = useCallback(() => setIsSuccessVisible(false), []);
  const closeError = useCallback(() => setIsErrorVisible(false), []);

  const confirm = useCallback(async () => {
    setIsConfirmVisible(false);
    setIsErrorVisible(false);
    try {
      await applyFunds(selectedIds);
      onApplied();
      setIsSuccessVisible(true);
    } catch {
      setIsErrorVisible(true);
    }
  }, [applyFunds, selectedIds, onApplied]);

  return {
    isConfirmVisible,
    isSuccessVisible,
    isErrorVisible,
    openConfirm,
    closeConfirm,
    closeSuccess,
    closeError,
    confirm,
  };
};
